// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__16sRA","rotation":"Loader_rotation__3iVRh"};